import { resetCalendarUpNextState, setLastEnterUpNext } from '../actions/timePanelDndStoreActions';
import { doNothingOnDrop } from '../utils/doNothingOnDrop';
import { observer } from 'mobx-react-lite';
import { addMilliseconds, compare, now } from 'owa-datetime';
import { DragData, DraggableItemTypes, Droppable } from 'owa-dnd';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getActiveCharm, HeaderCharmType } from 'owa-header-store';
import { isTimePanelAvailable } from 'owa-time-panel-bootstrap';
import * as React from 'react';
import {
    getLastDragOverUpNext,
    getUpNextDropState,
    shouldShowUpNextHoverHint,
} from '../selectors/timePanelDndStoreSelectors';

const styles = require('./UpNextDroppable.scss');
const classNames = require('classnames');

const HOVER_WAIT_TIME = 1000;

export interface UpNextDroppableProps {
    onLongHover: () => void;
    containerClassName: string;
    children?: React.ReactNode;
}

export default observer(function UpNextDroppable(props: UpNextDroppableProps) {
    const { children, containerClassName, onLongHover } = props;

    const shouldShowDroppableUpNext =
        isFeatureEnabled('cal-time-panel-dragEscalateMeeting') &&
        isTimePanelAvailable() &&
        getActiveCharm() !== HeaderCharmType.TimePanelCharm &&
        shouldShowUpNextHoverHint();

    const onDragOverCallback = React.useCallback(() => {
        handleDragOver(onLongHover);
    }, [onLongHover]);

    if (!shouldShowDroppableUpNext) {
        return <>{children}</>;
    }

    return (
        <Droppable
            dropViewState={getUpNextDropState()}
            canDrop={canDrop}
            onDragEnter={startHoverTimer}
            onDragOver={onDragOverCallback}
            onDrop={doNothingOnDrop}
            classNames={classNames(containerClassName, droppableStyles())}>
            {children}
        </Droppable>
    );
});

/**
 * Trigger onLongHover callback after 1s
 */
function handleDragOver(onLongHover: () => void) {
    if (compare(addMilliseconds(getLastDragOverUpNext(), HOVER_WAIT_TIME), now()) <= 0) {
        resetCalendarUpNextState();
        onLongHover();
    }
}

function droppableStyles(): string {
    return classNames(styles.dropContainer, {
        [styles.dropContainerActive]: getUpNextDropState().isDragOver,
    });
}

function canDrop(dragInfo: DragData) {
    return dragInfo.itemType === DraggableItemTypes.MailListRow;
}

function startHoverTimer(dragInfo: DragData): void {
    setLastEnterUpNext(now());
}
